import React, { useCallback, useMemo, useRef, useState } from "react";
import { classifyWaterfallPoint, normalizeLegendItems, WaterfallLegend } from "./waterfallLegend";
export const useWaterfallLegend = ({ rawLegendItems, waterfallOptions }) => {
    const legendItems = useMemo(() => normalizeLegendItems(rawLegendItems), [rawLegendItems]);
    const [hiddenKeys, setHiddenKeys] = useState(new Set());
    const chartElementRef = useRef(null);
    const classifyPoint = useCallback(classifyWaterfallPoint, []);
    const toggleKey = (key) => {
        const next = new Set(hiddenKeys);
        if (next.has(key)) {
            next.delete(key);
        }
        else {
            next.add(key);
        }
        setHiddenKeys(next);
        const chart = chartElementRef.current || null;
        if (chart?.chart?.series?.[0]) {
            chart.chart.series[0].points.forEach((pt) => {
                const typeKey = classifyPoint(pt);
                const shouldHide = next.has(typeKey);
                pt.setVisible(!shouldHide, false);
            });
            chart.chart.redraw();
        }
    };
    const renderLegend = () => {
        if (!legendItems.length) {
            return null;
        }
        const increaseColor = waterfallOptions?.upColor || "var(--chart-series-color-1, #0073C2)";
        const decreaseColor = waterfallOptions?.color || "var(--chart-series-color-2, #C736E0)";
        const totalColor = waterfallOptions?.sumColor || "var(--chart-semantic-neutral, #9FA2A7)";
        return React.createElement(WaterfallLegend, { items: legendItems, hidden: hiddenKeys, toggle: toggleKey, colors: { decrease: decreaseColor, increase: increaseColor, total: totalColor } });
    };
    return { chartElementRef, hiddenKeys, legendItems, renderLegend, toggleKey };
};
